import { Route } from "@angular/router";
import { authGuard } from "@core/guards";
import { CompaniesPageComponent } from "./components/companies-page/companies-page.component";
import { CompanyProfilePageComponent } from "./components/company-profile-page/company-profile-page.component";

export function getCompaniesRoutes(): Route[] {
  return [
    {
      path: 'companies',
      canActivate: [authGuard],
      canActivateChild: [authGuard],
      children: [
        {
          title: 'Companies',
          path: '',
          component: CompaniesPageComponent,
        },
        {
          title: "Company Profile",
          path: ':id',
          component: CompanyProfilePageComponent,
        },
      ]
    }
  ];
}
